import React from "react";
import "./FeaturesSection.css";

const FeaturesSection = () => {
  return (
    <section className="features-modern-section">
      <div className="features-modern-container">
        {/* Decorative Background Blobs */}
        <div className="blob blob-orange"></div>
        <div className="blob blob-coral"></div>
        <div className="blob blob-blue"></div>
        <div className="blob blob-navy"></div>

        <h2 className="features-modern-title">
          Why Choose <span className="title-gradient">Kitty n' Mice</span>
        </h2>

        <div className="features-modern-grid">
          {/* Free Delivery Feature */}
          <div className="feature-modern feature-modern-orange">
            <div className="feature-modern-icon-wrap">
              <div className="icon-circle icon-circle-orange">
                <svg
                  width="50"
                  height="50"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="1" y="3" width="15" height="13" />
                  <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
                  <circle cx="5.5" cy="18.5" r="2.5" />
                  <circle cx="18.5" cy="18.5" r="2.5" />
                </svg>
              </div>
              <div className="emoji-float emoji-1">🎁</div>
            </div>
            <h3 className="feature-modern-title-text">Free Delivery</h3>
            <p className="feature-modern-desc">On all orders above ₹999</p>
          </div>

          {/* Easy Exchange Feature */}
          <div className="feature-modern feature-modern-coral">
            <div className="feature-modern-icon-wrap">
              <div className="icon-circle icon-circle-coral">
                <svg
                  width="50"
                  height="50"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="17 1 21 5 17 9" />
                  <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                  <polyline points="7 23 3 19 7 15" />
                  <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                </svg>
              </div>
              <div className="emoji-float emoji-2">🔄</div>
            </div>
            <h3 className="feature-modern-title-text">Easy Exchange</h3>
            <p className="feature-modern-desc">Hassle-free 5-7 days returns</p>
          </div>

          {/* Secure Payment Feature */}
          <div className="feature-modern feature-modern-blue">
            <div className="feature-modern-icon-wrap">
              <div className="icon-circle icon-circle-blue">
                <svg
                  width="50"
                  height="50"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
              </div>
              <div className="emoji-float emoji-3">🔒</div>
            </div>
            <h3 className="feature-modern-title-text">Secure Payment</h3>
            <p className="feature-modern-desc">100% safe transactions</p>
          </div>

          {/* Premium Quality Feature */}
          <div className="feature-modern feature-modern-navy">
            <div className="feature-modern-icon-wrap">
              <div className="icon-circle icon-circle-navy">
                <svg
                  width="50"
                  height="50"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
              </div>
              <div className="emoji-float emoji-4">✨</div>
            </div>
            <h3 className="feature-modern-title-text">Premium Quality</h3>
            <p className="feature-modern-desc">Soft & comfy fabrics</p>
          </div>
        </div>

        {/* Decorative Elements */}
        <div className="decorative-dots dots-left"></div>
        <div className="decorative-dots dots-right"></div>
      </div>
    </section>
  );
};

export default FeaturesSection;
